export default {
    name: 'categorieProductSection',
    // created: {
    // },

};
